import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7071/agencies";
	}
	getAllUsersInformation(e) {
		let t = this.baseUrl + "/GetAllUsersInformation";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAllUsersInformation(e)));
	}
	processGetAllUsersInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgencyMembers(e, t) {
		let n = this.baseUrl + "/GetAgencyMembers?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetAgencyMembers(e)));
	}
	processGetAgencyMembers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getTeamsForAgency(e, t) {
		let n = this.baseUrl + "/GetTeamsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetTeamsForAgency(e)));
	}
	processGetTeamsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setTeamsForAgency(e, t) {
		let n = this.baseUrl + "/SetTeamsForAgency";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetTeamsForAgency(e)));
	}
	processSetTeamsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	deleteAgencySupplier(e, t) {
		let n = this.baseUrl + "/DeleteAgencySupplier";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processDeleteAgencySupplier(e)));
	}
	processDeleteAgencySupplier(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgencySuppliers(e, t) {
		let n = this.baseUrl + "/GetAgencySuppliers?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetAgencySuppliers(e)));
	}
	processGetAgencySuppliers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateAgencySuppliers(e, t) {
		let n = this.baseUrl + "/UpdateAgencySuppliers";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateAgencySuppliers(e)));
	}
	processUpdateAgencySuppliers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAutopilotEntityDetails(e) {
		let t = this.baseUrl + "/GetAutopilotEntityDetails";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAutopilotEntityDetails(e)));
	}
	processGetAutopilotEntityDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	sendInvitationEmail(e, t) {
		let n = this.baseUrl + "/SendInvitationEmail";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSendInvitationEmail(e)));
	}
	processSendInvitationEmail(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	softDeleteAgent(e, t) {
		let n = this.baseUrl + "/SoftDeleteAgent";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSoftDeleteAgent(e)));
	}
	processSoftDeleteAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgenciesAssignedToStaffMember(e, t) {
		let n = this.baseUrl + "/GetAgenciesAssignedToStaffMember";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetAgenciesAssignedToStaffMember(e)));
	}
	processGetAgenciesAssignedToStaffMember(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getStaffMembersAssignedToAgencies(e, t, n) {
		let r = this.baseUrl + "/GetStaffMembersAssignedToAgencies?";
		if (e == null) throw new globalThis.Error("The parameter 'role' must be defined and cannot be null.");
		r += "role=" + encodeURIComponent("" + e) + "&", t != null && t && t.forEach((e) => {
			r += "agencyIds=" + encodeURIComponent("" + e) + "&";
		}), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetStaffMembersAssignedToAgencies(e)));
	}
	processGetStaffMembersAssignedToAgencies(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	assignStaffMemberToAgencies(e, t) {
		let n = this.baseUrl + "/AssignStaffMemberToAgencies";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processAssignStaffMemberToAgencies(e)));
	}
	processAssignStaffMemberToAgencies(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetAgentsInAgency(e, t) {
		let n = this.baseUrl + "/StaffGetAgentsInAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetAgentsInAgency(e)));
	}
	processStaffGetAgentsInAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetAllAgents(e) {
		let t = this.baseUrl + "/StaffGetAllAgents";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffGetAllAgents(e)));
	}
	processStaffGetAllAgents(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetAnnualBusinessTargets(e, t) {
		let n = this.baseUrl + "/StaffGetAnnualBusinessTargets?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetAnnualBusinessTargets(e)));
	}
	processStaffGetAnnualBusinessTargets(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data, i = null;
			return i = r, A("Payload of String", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetPartnershipDetailsForAgency(e, t) {
		let n = this.baseUrl + "/StaffGetPartnershipDetailsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetPartnershipDetailsForAgency(e)));
	}
	processStaffGetPartnershipDetailsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSetAnnualBusinessTargets(e, t) {
		let n = this.baseUrl + "/StaffSetAnnualBusinessTargets";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffSetAnnualBusinessTargets(e)));
	}
	processStaffSetAnnualBusinessTargets(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data, i = null;
			return i = r, A("Payload of String", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffSetPartnershipDetailsForAgency(e, t) {
		let n = this.baseUrl + "/StaffSetPartnershipDetailsForAgency";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffSetPartnershipDetailsForAgency(e)));
	}
	processStaffSetPartnershipDetailsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateAutopilotEntityDetails(e, t) {
		let n = this.baseUrl + "/UpdateAutopilotEntityDetails";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateAutopilotEntityDetails(e)));
	}
	processUpdateAutopilotEntityDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setUrbanXTeamForAgency(e, t) {
		let n = this.baseUrl + "/SetUrbanXTeamForAgency";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetUrbanXTeamForAgency(e)));
	}
	processSetUrbanXTeamForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getUrbanXTeamForAgency(e, t) {
		let n = this.baseUrl + "/GetUrbanXTeamForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetUrbanXTeamForAgency(e)));
	}
	processGetUrbanXTeamForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getBranding(e, t) {
		let n = this.baseUrl + "/GetBranding?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetBranding(e)));
	}
	processGetBranding(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCommissionSettings(e, t) {
		let n = this.baseUrl + "/GetCommissionSettings?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCommissionSettings(e)));
	}
	processGetCommissionSettings(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getContractSettings(e, t) {
		let n = this.baseUrl + "/GetContractSettings?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetContractSettings(e)));
	}
	processGetContractSettings(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getListingAgreementSettings(e, t) {
		let n = this.baseUrl + "/GetListingAgreementSettings?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetListingAgreementSettings(e)));
	}
	processGetListingAgreementSettings(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateBranding(e, t, n) {
		let r = this.baseUrl + "/UpdateBranding";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined.");
		r = r.replace("{agencyId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateBranding(e)));
	}
	processUpdateBranding(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateCommissionSettings(e, t, n) {
		let r = this.baseUrl + "/UpdateCommissionSettings";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined.");
		r = r.replace("{agencyId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateCommissionSettings(e)));
	}
	processUpdateCommissionSettings(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateContractSettings(e, t, n) {
		let r = this.baseUrl + "/UpdateContractSettings";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined.");
		r = r.replace("{agencyId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateContractSettings(e)));
	}
	processUpdateContractSettings(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateListingAgreementSettings(e, t, n) {
		let r = this.baseUrl + "/UpdateListingAgreementSettings";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined.");
		r = r.replace("{agencyId}", encodeURIComponent("" + e)), r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateListingAgreementSettings(e)));
	}
	processUpdateListingAgreementSettings(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgencyRexId(e, t) {
		let n = this.baseUrl + "/GetAgencyRexId?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetAgencyRexId(e)));
	}
	processGetAgencyRexId(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateAgencyRexId(e, t) {
		let n = this.baseUrl + "/UpdateAgencyRexId";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateAgencyRexId(e)));
	}
	processUpdateAgencyRexId(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200 || t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getExecutiveKeyBudget(e) {
		let t = this.baseUrl + "/GetExecutiveKeyBudget";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetExecutiveKeyBudget(e)));
	}
	processGetExecutiveKeyBudget(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setExecutiveKeyBudget(e, t) {
		let n = this.baseUrl + "/SetExecutiveKeyBudget";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetExecutiveKeyBudget(e)));
	}
	processSetExecutiveKeyBudget(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getEntityGoals(e) {
		let t = this.baseUrl + "/GetEntityGoals";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetEntityGoals(e)));
	}
	processGetEntityGoals(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPartnershipDetailsForAgency(e) {
		let t = this.baseUrl + "/GetPartnershipDetailsForAgency";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetPartnershipDetailsForAgency(e)));
	}
	processGetPartnershipDetailsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setEntityGoals(e, t) {
		let n = this.baseUrl + "/SetEntityGoals";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetEntityGoals(e)));
	}
	processSetEntityGoals(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getFeatureToggles(e) {
		let t = this.baseUrl + "/GetFeatureToggles";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetFeatureToggles(e)));
	}
	processGetFeatureToggles(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetFeatureToggleManagement(e) {
		let t = this.baseUrl + "/StaffGetFeatureToggleManagement";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffGetFeatureToggleManagement(e)));
	}
	processStaffGetFeatureToggleManagement(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetFeatureToggles(e, t) {
		let n = this.baseUrl + "/StaffGetFeatureToggles?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetFeatureToggles(e)));
	}
	processStaffGetFeatureToggles(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffUpdateFeatureToggleManagement(e, t) {
		let n = this.baseUrl + "/StaffUpdateFeatureToggleManagement";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffUpdateFeatureToggleManagement(e)));
	}
	processStaffUpdateFeatureToggleManagement(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getUploadedFileLink(e, t) {
		let n = this.baseUrl + "/GetUploadedFileLink?";
		if (e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		n += "filePath=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetUploadedFileLink(e)));
	}
	processGetUploadedFileLink(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	removeFile(e, t) {
		let n = this.baseUrl + "/RemoveFile";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRemoveFile(e)));
	}
	processRemoveFile(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	removePublicDocument(e, t) {
		let n = this.baseUrl + "/RemovePublicDocument";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRemovePublicDocument(e)));
	}
	processRemovePublicDocument(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	uploadDocument(e, t) {
		let n = this.baseUrl + "/UploadDocument";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUploadDocument(e)));
	}
	processUploadDocument(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	uploadPublicDocument(e, t) {
		let n = this.baseUrl + "/UploadPublicDocument?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "POST",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUploadPublicDocument(e)));
	}
	processUploadPublicDocument(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPublicHolidays(e, t) {
		let n = this.baseUrl + "/GetPublicHolidays?";
		e != null && (n += "state=" + encodeURIComponent("" + e) + "&"), n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetPublicHolidays(e)));
	}
	processGetPublicHolidays(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	createAgent(e, t) {
		let n = this.baseUrl + "/CreateAgent";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCreateAgent(e)));
	}
	processCreateAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setAgentDetails(e, t) {
		let n = this.baseUrl + "/SetAgentDetails";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetAgentDetails(e)));
	}
	processSetAgentDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	createAgency(e, t) {
		let n = this.baseUrl + "/CreateAgency";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCreateAgency(e)));
	}
	processCreateAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgencyDetails(e, t) {
		let n = this.baseUrl + "/GetAgencyDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetAgencyDetails(e)));
	}
	processGetAgencyDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgencyInformationForUser(e) {
		let t = this.baseUrl + "/GetAgencyInformationForUser";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgencyInformationForUser(e)));
	}
	processGetAgencyInformationForUser(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgentsInAgency(e) {
		let t = this.baseUrl + "/GetAgentsInAgency";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgentsInAgency(e)));
	}
	processGetAgentsInAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAllAgencies(e) {
		let t = this.baseUrl + "/GetAllAgencies";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAllAgencies(e)));
	}
	processGetAllAgencies(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateAgency(e, t) {
		let n = this.baseUrl + "/UpdateAgency";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateAgency(e)));
	}
	processUpdateAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.None = "None", e.RealEstateCertificate = "RealEstateCertificate", e.RealEstateLicence = "RealEstateLicence", e.Class1 = "Class1", e.Class2 = "Class2", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.RPData = "RPData", e.RealEstateDotCom = "RealEstateDotCom", e.DomainDotCom = "DomainDotCom", e.DocuSign = "DocuSign", e.Rex = "Rex", e.CampaignFlow = "CampaignFlow", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.QLDResidentialForm6 = "QLDResidentialForm6", e.NSWResidentialAgreement = "NSWResidentialAgreement", e.NSWRuralAgreement = "NSWRuralAgreement", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.None = "None", e.RealEstateCertificate = "RealEstateCertificate", e.RealEstateLicence = "RealEstateLicence", e.Class1 = "Class1", e.Class2 = "Class2", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.ConfirmWithAgent = "ConfirmWithAgent", e.Original = "Original", e.Reduced = "Reduced", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.SellerSolicitorEarlyDeposit = "SellerSolicitorEarlyDeposit", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.AgentOrTeam = "AgentOrTeam", e.Agency = "Agency", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.SellerSolicitorEarlyDeposit = "SellerSolicitorEarlyDeposit", e;
}({}), k = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isAgenciesApiException = !0;
	static isAgenciesApiException(e) {
		return e.isAgenciesApiException === !0;
	}
};
function A(e, t, n, r, i) {
	throw i ?? new k(e, t, n, r, null);
}
function j(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var M = "agencies";
function N(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var P = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), N(r);
}, F = ({ baseApiUri: e, devMode: t, localUris: n }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	let r = n?.[M];
	return t && r ? r : `${e}/${M}`;
}, I = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = F(i), u = c, d = P(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(P(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, L = a({}), R = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = I(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(L.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, z = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAllUsersInformation"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAllUsersInformation(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, B = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAllUsersInformation"] });
	}, e[0] = t, e[1] = n), n;
}, V = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyMembers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyMembers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, H = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyMembers", e] });
	}, e[0] = t, e[1] = n), n;
}, U = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getTeamsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getTeamsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, W = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getTeamsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, G = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setTeamsForAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setTeamsForAgency: u,
		setTeamsForAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, K = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.deleteAgencySupplier(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		deleteAgencySupplier: u,
		deleteAgencySupplierPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, q = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getAgencySuppliers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencySuppliers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, J = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencySuppliers", e] });
	}, e[0] = t, e[1] = n), n;
}, Y = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAgencySuppliers(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAgencySuppliers: u,
		updateAgencySuppliersPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, X = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAutopilotEntityDetails"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAutopilotEntityDetails(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAutopilotEntityDetails"] });
	}, e[0] = t, e[1] = n), n;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.sendInvitationEmail(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		sendInvitationEmail: u,
		sendInvitationEmailPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ne = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.softDeleteAgent(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		softDeleteAgent: u,
		softDeleteAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, re = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getAgenciesAssignedToStaffMember(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getAgenciesAssignedToStaffMember: u,
		getAgenciesAssignedToStaffMemberPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ie = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(L), c;
	i[0] !== t || i[1] !== e ? (c = [
		"getStaffMembersAssignedToAgencies",
		e,
		t
	], i[0] = t, i[1] = e, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== t || i[4] !== s || i[5] !== e ? (d = (n) => {
		let { signal: r } = n;
		return s.getStaffMembersAssignedToAgencies(e, t, r);
	}, i[3] = t, i[4] = s, i[5] = e, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getStaffMembersAssignedToAgencies",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.assignStaffMemberToAgencies(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		assignStaffMemberToAgencies: u,
		assignStaffMemberToAgenciesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, se = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAgentsInAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAgentsInAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAgentsInAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, le = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffGetAllAgents"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffGetAllAgents(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffGetAllAgents"] });
	}, e[0] = t, e[1] = n), n;
}, de = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAnnualBusinessTargets", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAnnualBusinessTargets(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAnnualBusinessTargets", e] });
	}, e[0] = t, e[1] = n), n;
}, pe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPartnershipDetailsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPartnershipDetailsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPartnershipDetailsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, he = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSetAnnualBusinessTargets(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSetAnnualBusinessTargets: u,
		staffSetAnnualBusinessTargetsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ge = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSetPartnershipDetailsForAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSetPartnershipDetailsForAgency: u,
		staffSetPartnershipDetailsForAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, _e = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAutopilotEntityDetails(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAutopilotEntityDetails: u,
		updateAutopilotEntityDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ve = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setUrbanXTeamForAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setUrbanXTeamForAgency: u,
		setUrbanXTeamForAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ye = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getUrbanXTeamForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getUrbanXTeamForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, be = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUrbanXTeamForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, xe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getBranding", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getBranding(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getBranding", e] });
	}, e[0] = t, e[1] = n), n;
}, Ce = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getCommissionSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCommissionSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, we = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCommissionSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, Te = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getContractSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getContractSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ee = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getContractSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, De = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getListingAgreementSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getListingAgreementSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Oe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getListingAgreementSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, ke = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateBranding(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateBranding: u,
		updateBrandingPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ae = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateCommissionSettings(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateCommissionSettings: u,
		updateCommissionSettingsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, je = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateContractSettings(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateContractSettings: u,
		updateContractSettingsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Me = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.updateListingAgreementSettings(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateListingAgreementSettings: u,
		updateListingAgreementSettingsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ne = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyRexId", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyRexId(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyRexId", e] });
	}, e[0] = t, e[1] = n), n;
}, Fe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAgencyRexId(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAgencyRexId: u,
		updateAgencyRexIdPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ie = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getExecutiveKeyBudget"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getExecutiveKeyBudget(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getExecutiveKeyBudget"] });
	}, e[0] = t, e[1] = n), n;
}, Re = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setExecutiveKeyBudget(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setExecutiveKeyBudget: u,
		setExecutiveKeyBudgetPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ze = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getEntityGoals"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getEntityGoals(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Be = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getEntityGoals"] });
	}, e[0] = t, e[1] = n), n;
}, Ve = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getPartnershipDetailsForAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getPartnershipDetailsForAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, He = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getPartnershipDetailsForAgency"] });
	}, e[0] = t, e[1] = n), n;
}, Ue = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setEntityGoals(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setEntityGoals: u,
		setEntityGoalsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, We = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getFeatureToggles"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getFeatureToggles(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getFeatureToggles"] });
	}, e[0] = t, e[1] = n), n;
}, Ke = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffGetFeatureToggleManagement"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffGetFeatureToggleManagement(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, qe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffGetFeatureToggleManagement"] });
	}, e[0] = t, e[1] = n), n;
}, Je = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["staffGetFeatureToggles", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetFeatureToggles(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ye = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetFeatureToggles", e] });
	}, e[0] = t, e[1] = n), n;
}, Xe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateFeatureToggleManagement(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateFeatureToggleManagement: u,
		staffUpdateFeatureToggleManagementPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ze = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Qe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, $e = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFile(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFile: u,
		removeFilePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, et = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removePublicDocument(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removePublicDocument: u,
		removePublicDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, tt = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.uploadDocument(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		uploadDocument: u,
		uploadDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, $ = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.uploadPublicDocument(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		uploadPublicDocument: u,
		uploadPublicDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, nt = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getPublicHolidays", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getPublicHolidays(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, rt = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getPublicHolidays", e] });
	}, e[0] = t, e[1] = n), n;
}, it = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createAgent(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createAgent: u,
		createAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, at = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setAgentDetails(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setAgentDetails: u,
		setAgentDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ot = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createAgency: u,
		createAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, st = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ct = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, lt = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgencyInformationForUser"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgencyInformationForUser(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ut = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgencyInformationForUser"] });
	}, e[0] = t, e[1] = n), n;
}, dt = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgentsInAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgentsInAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ft = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgentsInAgency"] });
	}, e[0] = t, e[1] = n), n;
}, pt = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAllAgencies"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAllAgencies(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, mt = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAllAgencies"] });
	}, e[0] = t, e[1] = n), n;
}, ht = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAgency(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAgency: u,
		updateAgencyPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { L as AgenciesApiContext, k as AgenciesApiException, R as AgenciesApiProvider, f as AgenciesClient, M as AgenciesRoute, p as AgencyAccountType, m as AgencyAgentModelLicenceType, h as AgencyDetailsModelAccountType, y as AgentDetailsLicenceType, _ as Agreements, b as CommissionSettingsCommissionAdjustmentSalePriceReduced, S as ContractSettingsUnconditionalDisplayAs, x as ContractSettingsUnderOfferDisplayAs, C as CustomEmailParagraphState, g as ExternalIntegrations, w as FileUploadRequestDocumentType, ee as LicenceDetailsState, te as PartnershipDetailsPartnershipLevel, T as PartnershipTierLevel, E as SetEntityGoalsRequestEntityType, v as States, D as UpdateAgencyDetailsAccountType, O as UploadedDocumentDocumentType, I as useAgenciesClientContext, oe as useAssignStaffMemberToAgencies, ot as useCreateAgency, it as useCreateAgent, K as useDeleteAgencySupplier, re as useGetAgenciesAssignedToStaffMember, st as useGetAgencyDetails, lt as useGetAgencyInformationForUser, V as useGetAgencyMembers, Ne as useGetAgencyRexId, q as useGetAgencySuppliers, dt as useGetAgentsInAgency, pt as useGetAllAgencies, z as useGetAllUsersInformation, X as useGetAutopilotEntityDetails, xe as useGetBranding, Ce as useGetCommissionSettings, Te as useGetContractSettings, ze as useGetEntityGoals, Ie as useGetExecutiveKeyBudget, We as useGetFeatureToggles, De as useGetListingAgreementSettings, Ve as useGetPartnershipDetailsForAgency, nt as useGetPublicHolidays, ie as useGetStaffMembersAssignedToAgencies, U as useGetTeamsForAgency, Ze as useGetUploadedFileLink, ye as useGetUrbanXTeamForAgency, ct as useInvalidateUseGetAgencyDetails, ut as useInvalidateUseGetAgencyInformationForUser, H as useInvalidateUseGetAgencyMembers, Pe as useInvalidateUseGetAgencyRexId, J as useInvalidateUseGetAgencySuppliers, ft as useInvalidateUseGetAgentsInAgency, mt as useInvalidateUseGetAllAgencies, B as useInvalidateUseGetAllUsersInformation, Z as useInvalidateUseGetAutopilotEntityDetails, Se as useInvalidateUseGetBranding, we as useInvalidateUseGetCommissionSettings, Ee as useInvalidateUseGetContractSettings, Be as useInvalidateUseGetEntityGoals, Le as useInvalidateUseGetExecutiveKeyBudget, Ge as useInvalidateUseGetFeatureToggles, Oe as useInvalidateUseGetListingAgreementSettings, He as useInvalidateUseGetPartnershipDetailsForAgency, rt as useInvalidateUseGetPublicHolidays, ae as useInvalidateUseGetStaffMembersAssignedToAgencies, W as useInvalidateUseGetTeamsForAgency, Qe as useInvalidateUseGetUploadedFileLink, be as useInvalidateUseGetUrbanXTeamForAgency, ce as useInvalidateUseStaffGetAgentsInAgency, ue as useInvalidateUseStaffGetAllAgents, fe as useInvalidateUseStaffGetAnnualBusinessTargets, qe as useInvalidateUseStaffGetFeatureToggleManagement, Ye as useInvalidateUseStaffGetFeatureToggles, me as useInvalidateUseStaffGetPartnershipDetailsForAgency, $e as useRemoveFile, et as useRemovePublicDocument, Q as useSendInvitationEmail, at as useSetAgentDetails, Ue as useSetEntityGoals, Re as useSetExecutiveKeyBudget, G as useSetTeamsForAgency, ve as useSetUrbanXTeamForAgency, ne as useSoftDeleteAgent, se as useStaffGetAgentsInAgency, le as useStaffGetAllAgents, de as useStaffGetAnnualBusinessTargets, Ke as useStaffGetFeatureToggleManagement, Je as useStaffGetFeatureToggles, pe as useStaffGetPartnershipDetailsForAgency, he as useStaffSetAnnualBusinessTargets, ge as useStaffSetPartnershipDetailsForAgency, Xe as useStaffUpdateFeatureToggleManagement, ht as useUpdateAgency, Fe as useUpdateAgencyRexId, Y as useUpdateAgencySuppliers, _e as useUpdateAutopilotEntityDetails, ke as useUpdateBranding, Ae as useUpdateCommissionSettings, je as useUpdateContractSettings, Me as useUpdateListingAgreementSettings, tt as useUploadDocument, $ as useUploadPublicDocument };
